"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors; // eslint-disable-next-line react/prop-types

var HighlightSvg = function HighlightSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-148.000000, -1206.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(124.000000, 1182.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    stroke: colors.legacy[color] || color,
    strokeWidth: "2.1875",
    fillRule: "nonzero",
    x: "9.09375",
    y: "9.09375",
    width: "29.8125",
    height: "29.8125",
    rx: "14.90625"
  }), /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "1",
    fillRule: "evenodd",
    transform: "translate(18.000000, 16.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6,0 C9.3137085,0 12,2.6862915 12,6 C12,8.22044953 10.793836,10.1591844 9.00096303,11.1967496 L9,13 C9,14.6568542 7.65685425,16 6,16 C4.34314575,16 3,14.6568542 3,13 L3.00003939,11.1973296 C1.20661355,10.159907 0,8.22086333 0,6 C0,2.6862915 2.6862915,0 6,0 Z",
    stroke: colors.legacy[color] || color,
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: colors.legacy[color] || color,
    x: "3",
    y: "11",
    width: "6",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: colors.legacy[color] || color,
    x: "3",
    y: "13",
    width: "6",
    height: "1",
    rx: "0.5"
  })))))));
};

var Highlight = (0, _styledComponents.default)(HighlightSvg).withConfig({
  displayName: "Highlight",
  componentId: "sc-kdhp25-0"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
Highlight.defaultProps = {
  color: "" + colors.brand.snswDarkGrey,
  height: 24,
  width: 24
};
var _default = Highlight;
exports.default = _default;